import account from './account';
import comercial from './comercial';

export default {
  account,
  comercial,
};
